import {ReactNode} from "react";
import {ThemeProvider, createTheme, responsiveFontSizes} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

export const theme = responsiveFontSizes(
  createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: ({ownerState}) => ({
            ...(ownerState.variant === "contained" &&
              ownerState.color === "primary" && {
                backgroundColor: "#202020",
                color: "#fff",
              }),
          }),
        },
      },
    },
  })
);

interface Props {
  children: ReactNode;
}
export default function ThemeContextProvider({children}: Props) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
